module.exports = __webpack_public_path__ + "static/hero-f9a386df45d2b75006d543fc1a5eb3a8.svg";